<!-- 06.11.2019: KOMPONENTE IM AUGENBLICK NICHT MEHR IN BENUTZUNG -->
<template>
    <div class="subscribe">
        <div id='login-webbook' v-html="this.$parent.webbook.subscribe"></div>
        <div id='login-webbook-notext' v-if="!this.$parent.webbook.subscribe">
            <h3>Bestellen Sie ein Abonnement!</h3>
        </div>
        <div id='subscribe-link'>
            <a href="https://neu.infomarkt-shop.de/?digisubscribe">Hier geht es zu den Abonnements!</a>
        </div>
    </div>    
</template>

<script>
export default {
    name: "Subscribe",
    props: {        
    },
    created() {
    },
    data() {
        return {
        };
    },    
    methods: {
    }
};
</script>

<style lang="css" src="../assets/css/Subscribe.css"/>